import { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SourceIcon from '@mui/icons-material/Source';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, FormControl, Grid, IconButton, InputAdornment, OutlinedInput, Stack, Typography } from '@mui/material';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useEffect } from 'react';

const uploadSingleFilePopup = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [documentFile, setDocumentFile] = useState([]);
    const [documentName, setDocumentName] = useState("");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDocumentChange = (e) => {
        const file = e.target.files[0];
      setDocumentName(file.name);
      setDocumentFile(file);
      }

    useEffect(() => {
        if (props.data.uploadFile) {
            setDocumentName(props.data.uploadFile);
            // setDocumentFile(props.data.file ? props.data.file : []);
        }
    }, [props.data]);

    const removeDocument = () => {
        setDocumentName("");
        setDocumentFile([]);
    }

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowData = props.node;
                rowData.setDataValue("file", documentFile);
                return documentName;
            }
        };
    });



    return (
        <div>
            <IconButton onClick={handleClickOpen}><SourceIcon color="warning"/></IconButton>
            <Dialog fullWidth maxWidth={'sm'}
                open={open}
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{"Upload documents"}</DialogTitle>



                <DialogContent>
                    {!documentName ?
                        <Stack className='w-full mb-16'>
                            <Box className='flex justify-center items-center'
                                sx={{

                                    height: 180,
                                    border: '1px dotted grey',
                                }}
                            >
                                <CloudUploadIcon fontSize={'large'} /><Typography className='ml-12' >Upload your image</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                    color="warning"
                                    className='ml-12'
                                >
                                    <input hidden type="file"
                                        onChange={(e) => handleDocumentChange(e)}
                                    />
                                    <Typography color="black">Browse</Typography>
                                </Button>
                            </Box>
                        </Stack>
                        :
                        <Stack className='w-full mb-16'>

                            <Box
                                className='flex justify-between'
                            >
                                <Grid className='flex'>
                                    <div>
                                        <FileCopyIcon fontSize={'large'} color="warning" className=' mt-20' />
                                    </div>
                                    <div>
                                        <Typography fontSize={'large'} className='ml-12 mt-20' >{documentName}</Typography>

                                    </div>
                                </Grid>
                                <Grid>
                                    <FuseSvgIcon className='mt-20 w-32 h-32 cursor-pointer' onClick={() => removeDocument()}>heroicons-outline:x</FuseSvgIcon>
                                </Grid>
                            </Box>
                        </Stack>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button onClick={handleClose}>Uplaod</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    )
})

export default uploadSingleFilePopup